import { render, staticRenderFns } from "./IconMoon.vue?vue&type=template&id=4ca01356&scoped=true"
var script = {}
import style0 from "./IconMoon.vue?vue&type=style&index=0&id=4ca01356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca01356",
  null
  
)

export default component.exports